<div [hidden]="!isLoading" [ngClass]="getLoaderClasses()">
  <mat-progress-spinner
    mode="indeterminate"
    [strokeWidth]="2"
    [diameter]="size"
  ></mat-progress-spinner>
</div>
